"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var Component_1 = require("./Component");
var Sync_1 = require("@twii/core/lib/model/Sync");
var ComponentTypes = require("./ComponentTypes");
var Dashboard = /** @class */ (function (_super) {
    __extends(Dashboard, _super);
    function Dashboard() {
        var _this = _super.call(this) || this;
        _this.sync = new Sync_1.Sync();
        _this._saveDelay = 1000;
        _this._saveConfig = function (config) {
            _this.saver(config);
        };
        _this._loadDone = function (config) {
            _this.setConfig(config);
            if (_this.saver) {
                _this._configSaveDisposer = mobx_1.reaction(function () {
                    return _this.config;
                }, _this._saveConfig, { delay: _this.saveDelay });
            }
            _this.sync.syncEnd();
        };
        _this._loadError = function (error) {
            console.error(error);
            _this.setConfig(undefined);
            _this.sync.syncError(error);
        };
        _this._setComponentViewport = function () {
            if (_this._component) {
                _this._component.setViewport(0, 0, _this.width, _this.height);
            }
        };
        _this._setViewportDisposer = mobx_1.autorun(_this._setComponentViewport);
        return _this;
    }
    Object.defineProperty(Dashboard.prototype, "type", {
        get: function () {
            return ComponentTypes.dashboard;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dashboard.prototype, "dashboardList", {
        get: function () {
            return this.parent;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dashboard.prototype, "closeDisabled", {
        get: function () {
            return this._closeDisabled !== undefined ? this._closeDisabled : (this.dashboardList && this.dashboardList.closeDisabled);
        },
        set: function (value) {
            this.setCloseDisabled(value);
        },
        enumerable: true,
        configurable: true
    });
    Dashboard.prototype.setCloseDisabled = function (closeDisabled) {
        this._closeDisabled = closeDisabled;
    };
    Object.defineProperty(Dashboard.prototype, "component", {
        get: function () {
            return this._component;
        },
        set: function (value) {
            this.setComponent(value);
        },
        enumerable: true,
        configurable: true
    });
    Dashboard.prototype.setComponent = function (component) {
        if (component !== this._component) {
            if (component && component.parent !== this) {
                component.removeFromParent();
            }
            this._component = component;
            if (this._component) {
                this._component.parent = this;
            }
        }
    };
    Object.defineProperty(Dashboard.prototype, "windows", {
        get: function () {
            return this.findAll(function (c) { return c.type === ComponentTypes.window; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dashboard.prototype, "drag", {
        get: function () {
            return this._drag;
        },
        set: function (value) {
            this.setDrag(value);
        },
        enumerable: true,
        configurable: true
    });
    Dashboard.prototype.setDrag = function (drag) {
        this._drag = drag;
    };
    Dashboard.prototype.clearDrag = function () {
        this._drag = undefined;
    };
    Object.defineProperty(Dashboard.prototype, "blockSource", {
        get: function () {
            return this._blockSource;
        },
        set: function (value) {
            this.setBlockSource(value);
        },
        enumerable: true,
        configurable: true
    });
    Dashboard.prototype.setBlockSource = function (blockSource) {
        this._blockSource = blockSource;
    };
    Dashboard.prototype.clearBlockSource = function () {
        this._blockSource = undefined;
    };
    Object.defineProperty(Dashboard.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (value) {
            this.setTitle(value);
        },
        enumerable: true,
        configurable: true
    });
    Dashboard.prototype.setTitle = function (title) {
        this._title = title;
    };
    Object.defineProperty(Dashboard.prototype, "dashboard", {
        get: function () {
            return this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dashboard.prototype, "componentConfig", {
        get: function () {
            return this._component ? this._component.config : undefined;
        },
        set: function (config) {
            this.setComponentConfig(config);
        },
        enumerable: true,
        configurable: true
    });
    Dashboard.prototype.setComponentConfig = function (config) {
        if (config) {
            var c = this.componentFactory(config.type);
            this.setComponent(c);
            c.setConfig(config);
        }
        else {
            this.setComponent(undefined);
        }
        return Promise.resolve();
    };
    Object.defineProperty(Dashboard.prototype, "config", {
        get: function () {
            return {
                type: this.type,
                title: this.title,
                closeDisabled: this._closeDisabled,
                component: this.componentConfig
            };
        },
        set: function (value) {
            this.setConfig(value);
        },
        enumerable: true,
        configurable: true
    });
    Dashboard.prototype.setConfig = function (value) {
        this.sync.syncStart();
        this.setTitle(value ? value.title : undefined);
        this.setCloseDisabled(value ? value.closeDisabled : undefined);
        this.setComponentConfig(value ? value.component : undefined);
        this.sync.syncEnd();
    };
    Dashboard.prototype.remove = function (comp) {
        if (comp && this._component && comp === this._component) {
            this.setComponent(undefined);
            this.removeFromParent();
        }
    };
    Dashboard.prototype.replace = function (newComp, oldComp) {
        if (oldComp === this._component) {
            this.setComponent(newComp);
        }
    };
    Object.defineProperty(Dashboard.prototype, "saveDelay", {
        get: function () {
            return this._saveDelay;
        },
        set: function (value) {
            if (!isNaN(value) && value >= 0) {
                this._saveDelay = value;
            }
        },
        enumerable: true,
        configurable: true
    });
    Dashboard.prototype.load = function () {
        if (this._configSaveDisposer) {
            this._configSaveDisposer();
            delete this._configSaveDisposer;
        }
        if (this.loader) {
            this.sync.syncStart();
            return Promise.resolve(this.loader()).then(this._loadDone).catch(this._loadError);
        }
        return Promise.reject({ code: "ILLEGAL_STATE", message: "A loader has not been configured" });
    };
    Dashboard.prototype.clear = function () {
        this.setComponent(undefined);
    };
    Object.defineProperty(Dashboard.prototype, "isStackLayout", {
        get: function () {
            return this.component && this.component.type === "stack";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Dashboard.prototype, "isListLayout", {
        get: function () {
            return this.component && this.component.type === "list";
        },
        enumerable: true,
        configurable: true
    });
    Dashboard.prototype._visitChildren = function (callback) {
        if (this._component) {
            this._component.visit(callback);
        }
    };
    Dashboard.prototype._findFirstChild = function (predicate) {
        if (this._component) {
            return this._component.findFirst(predicate);
        }
    };
    Dashboard.prototype._findAllChildren = function (predicate) {
        if (this._component) {
            return this._component.findAll(predicate);
        }
    };
    Dashboard.prototype.close = function () {
        if (this._component) {
            this._component.close();
        }
    };
    __decorate([
        mobx_1.observable
    ], Dashboard.prototype, "sync", void 0);
    __decorate([
        mobx_1.observable
    ], Dashboard.prototype, "_title", void 0);
    __decorate([
        mobx_1.observable
    ], Dashboard.prototype, "_closeDisabled", void 0);
    __decorate([
        mobx_1.observable
    ], Dashboard.prototype, "_component", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Dashboard.prototype, "_drag", void 0);
    __decorate([
        mobx_1.observable.ref
    ], Dashboard.prototype, "_blockSource", void 0);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "dashboardList", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "closeDisabled", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "setCloseDisabled", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "component", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "setComponent", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "windows", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "drag", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "setDrag", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "clearDrag", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "blockSource", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "setBlockSource", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "clearBlockSource", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "title", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "setTitle", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "dashboard", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "componentConfig", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "setComponentConfig", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "config", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "setConfig", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "remove", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "replace", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "_loadDone", void 0);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "_loadError", void 0);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "load", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "clear", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "isStackLayout", null);
    __decorate([
        mobx_1.computed
    ], Dashboard.prototype, "isListLayout", null);
    __decorate([
        mobx_1.action
    ], Dashboard.prototype, "close", null);
    return Dashboard;
}(Component_1.Component));
exports.Dashboard = Dashboard;
